import { render, staticRenderFns } from "./KiosksList.vue?vue&type=template&id=077f6d8c&scoped=true&"
import script from "./KiosksList.vue?vue&type=script&lang=js&"
export * from "./KiosksList.vue?vue&type=script&lang=js&"
import style0 from "./KiosksList.vue?vue&type=style&index=0&id=077f6d8c&lang=scss&scoped=true&"
import style1 from "./KiosksList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077f6d8c",
  null
  
)

export default component.exports